<template>
    <div class="VideComp" :class="['is-'+ indice, { 'spirit': $route.meta.name == 'artwork' }]">
        <video ref="video" width="100%" height="100%" autoplay>
            <source 
                :src="require('@/commons/video/adad_hannah.webm')" 
                type="video/webm" 
                v-if="indice == 'adad'">
            <source 
                :src="require('@/commons/video/adad_hannah_2.mp4')" 
                type="video/mp4" 
                v-if="indice == 'adad'">
            <source 
                :src="require('@/commons/video/patrick_bernatchez.webm')" 
                type="video/webm" 
                v-if="indice == 'patrick'">
            <source 
                :src="require('@/commons/video/patrick_bernatchez_2.mp4')" 
                type="video/mp4" 
                v-if="indice == 'patrick'">
        </video> 
        <transition name="VideComp__play">
            <div 
                class="VideComp__play" 
                @click="onClick()" 
                v-if="useIcon()"></div>
        </transition>
    </div>
</template>
<script>

export default {
    name: 'VideComp',
    props: ['indice'],
    data: ()=>({
        used: false
    }),
    watch: {
        call_next(nw, od) {
            TweenMax.to(this.$refs.video, .2, { volume : 0 })
        },
    },
    computed: {
        call_next() { return this.$store.getters['app/call_next'] },
    },
    beforeDestroy() {
        this.$refs.video.pause() 
        this.$store.commit('app/VIDEO_IS_PLAYING', false)
    },
    mounted() {
        this.$store.commit('app/VIDEO_IS_PLAYING', true)
        this.$refs.video.volume = 0
        TweenMax.delayedCall(.5, ()=>{ 
            this.onEnded()
            this.$refs.video.onended = ()=>{
                this.onEnded()
            }  
        })
    }, 
    methods: {
        useIcon() {
            return navigator.maxTouchPoints == 5 && !this.used || this.$root.$agent.tablet && !this.used 
            ? true 
            : false
        },
        onClick() {
            this.$refs.video.play()
            this.used = true 
        },
        fadeIn() {
            this.$refs.video.volume = 0
            TweenMax.to(this.$refs.video, 5, { volume : .1 })
        },
        onEnded() {
            this.fadeIn()
            this.$refs.video.play() 
        },
    },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.VideComp  
    width 100vw
    max-width 600px
    height 400px
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    &.is-adad
        width 225px
        height 400px
        +max-screen-height(tablet-portrait)
            width 100%
            height 40% 

    &.spirit
        height 100% !important

    &.is-patrick
        width 600px
        height 297px
        +max-screen-height(tablet-portrait)
            height 100%
            height 40%

    &.spirit
        height 100% !important

    &__play 
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        width 48px 
        height 48px
        cursor pointer
        background-image url('~@/commons/img/play.png')
        background-size contain
        background-repeat no-repeat
        background-position center center
        transition opacity 1s, transform .5s
        &-enter
        &-leave-active
            opacity 0

</style>





// WEBPACK FOOTER //
// src/components/defis/components/VideoComp.vue